export enum EstadoDePedido {
  ABERTO = 'ABERTO',
  EM_PRODUCAO = 'EM_PRODUCAO',
  A_CAMINHO = 'A_CAMINHO',
  AGUARDANDO_RETIRADA = 'AGUARDANDO_RETIRADA',
  ENTREGUE = 'ENTREGUE',
  FINALIZADO = 'FINALIZADO',
  CANCELADO = 'CANCELADO'
}

export interface EstadoPedidoConfig {
  cor: string;
  icone: string;
  gradiente?: string;
}

/**
 * Fonte unica do par (icone, cor) de cada estado. Nenhum componente redefine
 * esses valores localmente, e todo botao que LEVA a um estado le o icone daqui.
 *
 * As cores sao `var(--avati-pedido-*)`, definidas em `styles/_tokens.scss`.
 * A indirecao funciona porque todo consumo e binding de CSS
 * ([style.background], [style.border-left-color]) e resolve no navegador.
 */
export const ESTADO_PEDIDO_CONFIG: Record<EstadoDePedido, EstadoPedidoConfig> = {
  [EstadoDePedido.ABERTO]:              { cor: 'var(--avati-pedido-aberto)', icone: 'pi pi-file' },
  [EstadoDePedido.EM_PRODUCAO]:         { cor: 'var(--avati-pedido-em-producao)', icone: 'pi pi-clock' },
  [EstadoDePedido.A_CAMINHO]:           { cor: 'var(--avati-pedido-a-caminho)', icone: 'pi pi-car' },
  [EstadoDePedido.AGUARDANDO_RETIRADA]: { cor: 'var(--avati-pedido-aguardando-retirada)', icone: 'pi pi-hourglass' },
  [EstadoDePedido.ENTREGUE]:            { cor: 'var(--avati-pedido-entregue)', icone: 'pi pi-check-square' },
  [EstadoDePedido.FINALIZADO]:          { cor: 'var(--avati-pedido-finalizado)', icone: 'pi pi-check-circle' },
  [EstadoDePedido.CANCELADO]:           { cor: 'var(--avati-pedido-cancelado)', icone: 'pi pi-times-circle' },
};

// Estados que aparecem no dropdown de transicao (conforme mobile)
export const ESTADOS_PARA_TRANSFERENCIA: EstadoDePedido[] = [
  EstadoDePedido.EM_PRODUCAO,
  EstadoDePedido.A_CAMINHO,
  EstadoDePedido.AGUARDANDO_RETIRADA,
  EstadoDePedido.CANCELADO,
];
